import { useState, useEffect } from 'react';
import { getImageUrl } from '@/utils/imageDB';

export function useImageUrl(id: string | undefined | null, fallbackUrl: string): string {
  const [url, setUrl] = useState<string>(fallbackUrl);

  useEffect(() => {
    let objectUrl: string | null = null;
    if (!id) {
      setUrl(fallbackUrl);
      return;
    }
    getImageUrl(id).then((result) => {
      if (result) {
        objectUrl = result;
        setUrl(result);
      } else {
        setUrl(fallbackUrl);
      }
    });
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id, fallbackUrl]);

  return url;
}
